import { GET_TERRITORIES_LIST, SET_TERRITORIES_LIST } from './constants';

export const getTerritoriesList = (payload) => ({
  type: GET_TERRITORIES_LIST,
  payload,
});

export const setTerritoriesList = (payload) => ({
  type: SET_TERRITORIES_LIST,
  payload,
});
